import { styled } from "@mui/material/styles";
import { Dialog, DialogTitle, DialogContent } from "@mui/material";

export const StyledDialog = styled(Dialog)(({ theme, maxWidth }) => ({
  "& .MuiDialog-paper": {
    maxWidth: maxWidth || "500px",
    width: "100%",
    margin: theme.spacing(2),
    borderRadius: "8px",
    [theme.breakpoints.down("sm")]: {
      maxWidth: "95vw",
      margin: theme.spacing(1),
    },
  },
}));

export const StyledDialogTitle = styled(DialogTitle)(({ theme }) => ({
  padding: "12px 16px",
  backgroundColor: theme.palette.background.paper,
  borderBottom: `1px solid ${theme.palette.divider}`,
  "& .MuiTypography-h6": {
    fontSize: "16px",
    fontWeight: 500,
  },
}));

export const StyledDialogContent = styled(DialogContent)(({ theme }) => ({
  padding: theme.spacing(2),
  "& .MuiGrid-container": {
    margin: 0,
    width: "100%",
    "& .MuiGrid-item": {
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
    },
  },
}));

export const HeaderContainer = styled("div")({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  "& .MuiIconButton-root": {
    padding: "4px",
  },
});

export const ButtonGroup = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  gap: theme.spacing(1.5),
  marginTop: theme.spacing(3),
  padding: theme.spacing(0, 1),
  width: "100%",
  "& .MuiButton-root": {
    flex: 1,
    minWidth: "120px",
    height: "32px",
    textTransform: "none",
    fontSize: "13px",
    borderRadius: "4px",
  },
  "& .MuiButton-outlined": {
    borderColor: theme.palette.divider,
    color: theme.palette.text.primary,
    backgroundColor: "transparent",
    "&:hover": {
      backgroundColor: "transparent",
      borderColor: theme.palette.primary.main,
    },
  },
  "& .MuiButton-contained": {
    backgroundColor: theme.palette.primary.main,
    color: "#fff",
    "&:hover": {
      backgroundColor: theme.palette.primary.dark,
    },
  },
}));

export const IconContainer = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1),
  "& .MuiSvgIcon-root": {
    fontSize: "20px",
    color: theme.palette.primary.main,
  },
  "& .MuiTypography-h6": {
    fontSize: "16px",
    fontWeight: 500,
  },
}));

export const GridContainer = styled("div")(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
  gap: theme.spacing(2.5),
  width: "100%",
  marginBottom: theme.spacing(2),
}));
